import * as S from "@/containers/Project/components/styled";
import { useProjectContext } from "@/providers";
import { faAngleDown, faAngleRight } from "@fortawesome/pro-solid-svg-icons";
import { Button } from "antd";
import { bool, func, number, object } from "prop-types";

const MilestonePanelHeaderSection = ({
  milestone,
  childLevel,
  expanded,
  toggleExpanded,
  toggleChildren,
}) => {
  const {
    milestoneListChildren: { topOnly, showOrHideChildren },
  } = useProjectContext();

  const areChildMilestonesVisible =
    (topOnly && showOrHideChildren.includes(milestone.id)) ||
    (!topOnly && !showOrHideChildren.includes(milestone.id));

  const isNameEdited =
    milestone.displayName && milestone.displayName !== milestone.name;

  return (
    <S.StatusAndNameCol>
      {childLevel === 0 && milestone.childMilestones?.length > 0 && (
        <S.StyledIcon
          icon={areChildMilestonesVisible ? faAngleDown : faAngleRight}
          $click={true}
          onClick={toggleChildren}
          data-test-id={`milestone-${milestone.id}-panel-header-section-expand-children`}
        />
      )}
      <S.StyledStatusIconContainer>
        <div
          data-test-id={`milestone-panel-header-section-status-${milestone.id}`}
          className={`status-${milestone.status?.toLowerCase()}
            ${childLevel === 0 ? ", major" : ""}`}
        />
      </S.StyledStatusIconContainer>
      <Button
        className="inline-block"
        type="text"
        data-test-id="milestone-name-btn"
        onClick={toggleExpanded}
        style={isNameEdited ? { backgroundColor: "#FFE6D5" } : {}}
        title={isNameEdited ? milestone.name : ""}
      >
        <S.StyledMilestoneName>
          {milestone.displayName || milestone.name}
        </S.StyledMilestoneName>
      </Button>
    </S.StatusAndNameCol>
  );
};

MilestonePanelHeaderSection.propTypes = {
  milestone: object,
  childLevel: number,
  expanded: bool,
  toggleExpanded: func,
  toggleChildren: func,
};

export { MilestonePanelHeaderSection };
